module.exports = __webpack_public_path__ + "static/media/dz.dea7ef63.svg";